<template>
  <v-container fluid>
        
    <form action="">
      <v-card outlined class="mb-3 pa-3">
        <v-row dense align="center">
          <v-col cols="auto">
            <v-autocomplete
              v-model="f_business"
              :items="f_business_list"
              label="Unidad de negocio"
              item-text="text"
              item-value="value"
              @change="f_onBusinessChange"
              dense outlined hide-details
              style="min-width:200px"
              prepend-inner-icon="mdi-office-building-outline"
            />
          </v-col>
          <v-col cols="auto">
            <v-autocomplete
              v-model="f_location"
              :items="f_locations_list"
              label="Sucursal"
              item-text="text"
              item-value="value"
              dense outlined hide-details
              style="min-width:180px"
              prepend-inner-icon="mdi-map-marker-outline"
            />
          </v-col>
          <v-col cols="auto">
            <v-menu v-model="f_menu_start" :close-on-content-click="false" offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :value="f_dateStart"
                  label="Desde"
                  readonly v-bind="attrs" v-on="on"
                  dense outlined hide-details
                  style="max-width:150px"
                  prepend-inner-icon="mdi-calendar-start"
                />
              </template>
              <v-date-picker v-model="f_dateStart" @input="f_menu_start = false" locale="es" />
            </v-menu>
          </v-col>
          <v-col cols="auto">
            <v-menu v-model="f_menu_end" :close-on-content-click="false" offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :value="f_dateEnd"
                  label="Hasta"
                  readonly v-bind="attrs" v-on="on"
                  dense outlined hide-details
                  style="max-width:150px"
                  prepend-inner-icon="mdi-calendar-end"
                />
              </template>
              <v-date-picker v-model="f_dateEnd" @input="f_menu_end = false" locale="es" />
            </v-menu>
          </v-col>
          <v-col cols="auto">
            <v-btn color="primary" @click="applyFilters" :loading="loading" small>
              <v-icon left small>mdi-magnify</v-icon>
              Aplicar
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
      <v-row justify="center" class="mt-n6">
        <v-col cols="12" md="12" aling="center">
          <v-card flat v-if="loading == false">

            <!-- Shared toolbar -->
            <v-toolbar flat dense>
              <v-btn icon small @click="goBack" class="mr-1">
                <v-icon small>mdi-arrow-left</v-icon>
              </v-btn>
              <v-toolbar-title class="text-subtitle-1 font-weight-bold">
                {{ accountTitle.name }}
                <v-chip x-small color="info" class="ml-1" v-if="accountTitle.hasChildren">Subcuentas incluidas</v-chip>
                - <span class="primary--text">{{ accountTitle.code }}</span>
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field
                v-if="view_mode === 'normal'"
                v-model="search"
                append-icon="search"
                hide-details outlined dense
                style="max-width:200px"
                class="mr-2"
              ></v-text-field>
              <v-btn
                v-if="view_mode === 'normal'"
                color="primary" outlined
                @click="exportToExcel"
                :loading="loading"
                class="mr-2 text-none"
              >
                <v-icon left small>mdi-microsoft-excel</v-icon>Excel
              </v-btn>
              <v-autocomplete
                v-if="view_mode === 'normal'"
                v-model="diary_book_type_id"
                :items="diary_book_types"
                label="Tipo de entrada"
                dense outlined hide-details
                prepend-inner-icon="mdi-book"
                item-text="description"
                item-value="id"
                style="max-width:180px"
                class="mr-3"
              ></v-autocomplete>
              <v-divider vertical class="mx-2" style="height:28px; align-self:center"></v-divider>
              <!-- Export button for department mode -->
              <v-btn
                v-if="view_mode === 'department'"
                color="primary" outlined small
                @click="exportDeptToExcel"
                class="mr-2 text-none"
              >
                <v-icon left small>mdi-microsoft-excel</v-icon>Excel
              </v-btn>
              <v-btn-toggle
                v-model="view_mode"
                mandatory dense
                class="ml-2"
                color="primary"
                @change="onViewModeChange"
              >
                <v-btn :value="'normal'" x-small text class="text-none">Normal</v-btn>
                <v-btn :value="'department'" x-small text class="text-none">
                  <v-icon x-small left>mdi-office-building</v-icon>Departamento
                </v-btn>
                <v-btn :value="'period'" x-small text class="text-none">
                  <v-icon x-small left>mdi-calendar-range</v-icon>Período
                </v-btn>
              </v-btn-toggle>
                 <v-spacer></v-spacer>
              <!-- Period selectors + export -->
              <template v-if="view_mode === 'period'">
                <v-autocomplete
                  v-model="current_calendar"
                  :items="calendars"
                  label="Calendario"
                  item-text="name"
                  item-value="accounting_calendar_id"
                  @change="onCalendarChange"
                  dense outlined hide-details
                  style="max-width:150px"
                  class="ml-2"
                  :no-data-text="lastFilters ? 'Sin calendarios' : 'Aplica filtros primero'"
                ></v-autocomplete>
                <v-select
                  v-model="current_period_id"
                  :items="period_periods_list"
                  label="Hasta período"
                  item-text="period_label_plain"
                  item-value="id"
                  @change="loadPeriodData"
                  dense outlined hide-details
                  style="max-width:260px"
                  class="ml-2"
                  no-data-text="Selecciona un calendario"
                >
                  <template v-slot:selection="{ item }">
                    <span v-html="item.period_label"></span>
                  </template>
                  <template v-slot:item="{ item, attrs, on }">
                    <v-list-item v-bind="attrs" v-on="on">
                      <v-list-item-content>
                        <span v-html="item.period_label"></span>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-select>
                <v-btn
                  color="primary" outlined small
                  @click="exportPeriodToExcel"
                  :disabled="period_raw_data.length === 0"
                  class="ml-2 text-none"
                >
                  <v-icon left small>mdi-microsoft-excel</v-icon>Excel
                </v-btn>
                <v-switch
                  v-model="period_only_with_movement"
                  label="Solo movimiento"
                  hide-details dense
                  class="ml-3 mt-0 pt-0"
                  style="max-width:160px"
                />
              </template>
            </v-toolbar>
            <v-divider></v-divider>

            <!-- Normal table -->
            <v-data-table
              v-if="view_mode === 'normal'"
              :items-per-page="100"
              :headers="tableHeaders"
              :items="computed_data_diary"
              :search="search"
              class="elevation-0"
              height="47vh"
              fixed-footer fixed-header
              locale="es-do"
              no-data-text="No hay entradas para mostrar."
              loading-text="Cargando items..."
              key="diary_book_id"
              :footer-props="{
                itemsPerPageText: 'Acciones por página:',
                'items-per-page-text': 'Lineas por pagina',
                'page-text': '{0}-{1} de {2}',
                'items-per-page-options': opts
              }"
            >
              <template v-slot:[`item.diary_book_code`]="{ item }">
                <v-hover v-slot="{ hover }">
                  <span
                    @click="showItem(item)"
                    class="primary--text font-weight-semibold"
                    :style="{ color: hover ? 'red' : 'black', cursor: hover ? 'pointer' : '', 'text-decoration': hover ? 'underline' : '' }"
                  >{{ item.diary_book_code }}</span>
                </v-hover>
              </template>
              <template v-slot:[`item.created_date`]="{ item }">
                <span class="font-weight-normal subtitle-3">{{ getDate(item.created_date) }}</span>
              </template>
              <template v-slot:[`item.chart_of_account_name`]="{ item }">
                <span class="primary--text">{{ item.chart_of_account_code }}</span>
                <span> - {{ item.chart_of_account_name }}</span>
              </template>
              <template v-slot:[`item.tercero`]="{ item }">
                <v-hover v-slot="{ hover }">
                  <span
                    @click="viewEntity(item.entity_id)"
                    class="primary--text font-weight-semibold"
                    :style="{ color: hover ? 'red' : 'black', cursor: hover ? 'pointer' : '', 'text-decoration': hover ? 'underline' : '' }"
                  >{{ item.entity_name }}</span>
                </v-hover>
              </template>
              <template v-slot:[`item.debito`]="{ item }">
                <span v-if="item.entry_type_id == 1" class="primary--text font-weight-medium">
                  {{ currencyFormat(item.amount * parseFloat(item.currency_rate == 0 ? 1 : item.currency_rate)) }}
                </span>
              </template>
              <template v-slot:[`item.credito`]="{ item }">
                <span v-if="item.entry_type_id == 2" class="error--text font-weight-medium">
                  {{ currencyFormat(item.amount * parseFloat(item.currency_rate == 0 ? 1 : item.currency_rate)) }}
                </span>
              </template>
            </v-data-table>

            <!-- Department pivot table -->
            <template v-else-if="view_mode === 'department'">
              <v-progress-linear v-if="loading_dept" indeterminate color="primary"></v-progress-linear>
              <div v-else-if="department_raw_data.length === 0" class="text-center py-10 grey--text">
                <v-icon size="52" color="grey lighten-2">mdi-table-off</v-icon>
                <div class="mt-2 text-body-2">Sin datos. Aplica los filtros para consultar.</div>
              </div>
              <div v-else class="dept-pivot-wrapper">
                <table class="dept-pivot-table">
                  <thead>
                    <tr>
                      <th class="dept-th dept-code-col">Código</th>
                      <th class="dept-th dept-name-col">Descripción</th>
                      <th v-for="dept in dept_columns" :key="dept.id" class="dept-th dept-amount-col">
                        <div class="dept-header-id">{{ dept.id }}</div>
                        <div class="dept-header-name">{{ dept.name }}</div>
                      </th>
                      <th class="dept-th dept-amount-col dept-total-col">Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="row in dept_pivot_rows" :key="row.chart_of_account_id" class="dept-row">
                      <td class="dept-td dept-code-col">{{ row.chart_of_account_code }}</td>
                      <td class="dept-td dept-name-col">{{ row.chart_of_account_name }}</td>
                      <td
                        v-for="dept in dept_columns" :key="dept.id"
                        class="dept-td dept-amount-col"
                        :class="getDeptAmount(row, dept.id) < 0 ? 'dept-negative' : getDeptAmount(row, dept.id) > 0 ? 'dept-positive' : 'dept-zero'"
                      >
                        {{ formatPivotAmount(getDeptAmount(row, dept.id)) }}
                      </td>
                      <td class="dept-td dept-amount-col dept-total-col"
                        :class="row.total < 0 ? 'dept-negative' : row.total > 0 ? 'dept-positive' : 'dept-zero'">
                        {{ formatPivotAmount(row.total) }}
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr class="dept-footer-row">
                      <td class="dept-td dept-footer-label" colspan="2">Total general</td>
                      <td
                        v-for="dept in dept_columns" :key="dept.id"
                        class="dept-td dept-amount-col"
                        :class="dept_totals[dept.id] < 0 ? 'dept-negative' : dept_totals[dept.id] > 0 ? 'dept-positive' : 'dept-zero'"
                      >
                        {{ formatPivotAmount(dept_totals[dept.id]) }}
                      </td>
                      <td class="dept-td dept-amount-col dept-total-col"
                        :class="dept_grand_total < 0 ? 'dept-negative' : dept_grand_total > 0 ? 'dept-positive' : 'dept-zero'">
                        {{ formatPivotAmount(dept_grand_total) }}
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </template>

            <!-- Period pivot table -->
            <template v-else-if="view_mode === 'period'">
              <v-progress-linear v-if="loading_period" indeterminate color="primary"></v-progress-linear>
              <div v-else-if="period_raw_data.length === 0" class="text-center py-10 grey--text">
                <v-icon size="52" color="grey lighten-2">mdi-calendar-clock</v-icon>
                <div class="mt-2 text-body-2">Sin datos. Selecciona un calendario y período.</div>
              </div>
              <div v-else class="dept-pivot-wrapper">
                <table class="dept-pivot-table">
                  <thead>
                    <tr>
                      <th class="dept-th dept-code-col">Cuenta</th>
                      <th class="dept-th dept-name-col">Descripción</th>
                      <th v-for="per in period_columns" :key="per.id" class="dept-th dept-amount-col">
                        {{ per.name }}
                      </th>
                      <th class="dept-th dept-amount-col dept-total-col">Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="row in period_pivot_rows_filtered" :key="row.chart_of_account_id" class="dept-row">
                      <td class="dept-td dept-code-col primary--text" style="cursor:pointer;font-weight:600" @click="drillDownAccount(row)">{{ row.chart_of_account_code }}</td>
                      <td class="dept-td dept-name-col">{{ row.chart_of_account_name }}</td>
                      <td
                        v-for="per in period_columns" :key="per.id"
                        class="dept-td dept-amount-col"
                        :class="getPeriodAmount(row, per.id) < 0 ? 'dept-negative' : getPeriodAmount(row, per.id) > 0 ? 'dept-positive' : 'dept-zero'"
                      >
                        {{ formatPivotAmount(getPeriodAmount(row, per.id)) }}
                      </td>
                      <td class="dept-td dept-amount-col dept-total-col"
                        :class="row.total < 0 ? 'dept-negative' : row.total > 0 ? 'dept-positive' : 'dept-zero'">
                        {{ formatPivotAmount(row.total) }}
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr class="dept-footer-row">
                      <td class="dept-td dept-footer-label" colspan="2">Total general</td>
                      <td
                        v-for="per in period_columns" :key="per.id"
                        class="dept-td dept-amount-col"
                        :class="period_totals[per.id] < 0 ? 'dept-negative' : period_totals[per.id] > 0 ? 'dept-positive' : 'dept-zero'"
                      >
                        {{ formatPivotAmount(period_totals[per.id]) }}
                      </td>
                      <td class="dept-td dept-amount-col dept-total-col"
                        :class="period_grand_total < 0 ? 'dept-negative' : period_grand_total > 0 ? 'dept-positive' : 'dept-zero'">
                        {{ formatPivotAmount(period_grand_total) }}
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </template>

            <!-- Totals bar (normal mode only) -->
            <v-card outlined v-if="view_mode === 'normal'" class="d-flex justify-end mt-2" style="padding: 16px; border-top: 1px solid #ccc;">
              <div style="min-width: 200px; text-align: right;">
                <span style="color: #00897B; font-size: 20px;">Debito: {{ currencyFormat(debitoAndCredito.debito) }}</span>
                <v-divider class="mx-4" inset vertical></v-divider>
                <span style="color: #FF0000; font-size: 20px;">Credito: {{ currencyFormat(debitoAndCredito.credito) }}</span><br />
                <strong>NETO:
                  <span class="success--text" style="font-size: 20px;">
                    {{ currencyFormat(debitoAndCredito.debito - debitoAndCredito.credito) }} {{ currency }}
                  </span>
                </strong>
              </div>
            </v-card>
          </v-card>
          <v-skeleton-loader
            v-else
            v-bind="attrs"
            type="list-item-avatar, divider, list-item-three-line, card-heading, image, actions"
            height="500px"
          ></v-skeleton-loader>

        </v-col>
      </v-row>
    </form>

    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      scrollable
    >
      <v-card>
        <ViewEntryDiary
          :entryDiary="selectedItem"
          @close="dialog = false"
          :key="selectedItem.diary_book_id"
        >
        </ViewEntryDiary>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import ExcelJS from "exceljs";

import moment from "moment";
import ViewEntryDiary from "../../components/Accounting/ViewEntryDiary";
export default {
  data: () => ({
    attrs: {
      class: "mb-12 mt-12",
      boilerplate: true,
      elevation: 2,
    },
    search:null,
    id_account: null,
    loading: false,
    showEntry: false,
    date: moment().startOf("month").format("YYYY-MM-DD"),
    date2: moment().endOf("month").format("YYYY-MM-DD"),
    menu: false,
    menu2: false,
    selectedCategoryDgii: "",
    categoryDgii: [],
    seletecName: "",
    dialog: false,
    items: [],
    itemsBussines: [],
    itemsLocations: [],
    itemsLocations2: [],
    itemsDepartment: [],
    itemSaved: [],
    ategoryDgii: [],
    newItem: [],
    itemsRoutes: [],
    editedItem: [],
    dataDiary: [],
    catalogue_id: null,
    editedIndex: -1,
    filters: {
      business: null,
      location: null,
      department_id: null,
      routes: "",
    },
    lastFilters: null,
    f_business: null,
    f_location: 0,
    f_dateStart: moment().startOf('month').format('YYYY-MM-DD'),
    f_dateEnd: moment().endOf('month').format('YYYY-MM-DD'),
    f_locations_list: [{ text: 'Todas', value: 0 }],
    f_menu_start: false,
    f_menu_end: false,
    period_only_with_movement: false,
    editedIndex: -1,
    dialog: false,
    dialogDelete: false,
    currency: null,
    opts:[30,60,100,-1],
    view_mode: sessionStorage.getItem('diary_view_mode') || 'normal',
    department_raw_data: [],
    loading_dept: false,
    calendars: [],
    current_calendar: null,
    period_periods_list: [],
    current_period_id: null,
    period_raw_data: [],
    loading_period: false,
    headers: [
      {
        text: "Asiento",
        align: "start",
        sortable: false,
        value: "diary_book_code",
      },
      {
        text: "Tipo",
        sortable: false,
        value: "diary_book_type_description",
      },
      {
        text: "Unidad de negocio",
        value: "business_unit_description",
        width: "15%",
        align: "center",
      },
      { text: "Fecha", value: "effective_date", width: "15%", align: "center" },

      { text: "Debito", value: "debito", align: "end" },
      { text: "Credito", value: "credito", align: "end" },
    ],
    rangeSelected: "",
    rangeTime: [
      { text: "Hoy", value: "1" },
      { text: "Este semana", value: "2" },
      { text: "Este mes", value: "3" },

      { text: "Este año", value: "4" },
    ],
    selectedItem: [],
    diary_book_type_id:0,
    diary_book_types:[],
  }),
  props: {
    entry: {
      type: Object,
      require: true,
    },
  },
  created() {
    // this.getData();
  },
  components: { ViewEntryDiary },
  watch: {
    current_period_id(newVal) {
      if (newVal) this.loadPeriodData();
    },
    f_dateStart() {
      clearTimeout(this._dateDebounce);
      this._dateDebounce = setTimeout(() => this.applyFilters(), 700);
    },
    f_dateEnd() {
      clearTimeout(this._dateDebounce);
      this._dateDebounce = setTimeout(() => this.applyFilters(), 700);
    },
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? "Crear cuenta contable "
        : "Editar cuenta contable ";
    },
    f_business_list() {
      const units = this.$store.state.auth.bussines_units || [];
      return [{ text: 'Todas', value: 0 }, ...units];
    },
    accountTitle() {
      const hasChildren = this.$route.query.has_children === '1';
      const name = this.$route.query.account_name || (this.computed_data_diary.length > 0 ? this.computed_data_diary[0].chart_of_account_name : '');
      const code = this.$route.query.account_code || (this.computed_data_diary.length > 0 ? this.computed_data_diary[0].chart_of_account_code : '');
      return { name, code, hasChildren };
    },
    tableHeaders() {
      const base = [
        { text: 'Asiento', align: 'start', sortable: false, value: 'diary_book_code' },
        { text: 'Tipo', sortable: false, value: 'diary_book_type_description' },
      ];
      if (this.accountTitle.hasChildren) {
        base.push({ text: 'Cuenta', value: 'chart_of_account_name', width: '25%' });
      }
      base.push(
        { text: 'Unidad de negocio', value: 'business_unit_description', width: '15%', align: 'center' },
        { text: 'Fecha', value: 'effective_date', width: '15%', align: 'center' },
        { text: this.currency ? `Débito (${this.currency})` : 'Débito', value: 'debito', align: 'end' },
        { text: this.currency ? `Crédito (${this.currency})` : 'Crédito', value: 'credito', align: 'end' },
      );
      return base;
    },
    dept_columns() {
      const map = new Map();
      for (const row of this.department_raw_data) {
        if (!map.has(row.department_id)) {
          map.set(row.department_id, { id: row.department_id, name: row.department_name });
        }
      }
      return Array.from(map.values()).sort((a, b) =>
        String(a.name).localeCompare(String(b.name))
      );
    },
    dept_pivot_rows() {
      const accountMap = new Map();
      for (const row of this.department_raw_data) {
        if (!accountMap.has(row.chart_of_account_id)) {
          accountMap.set(row.chart_of_account_id, {
            chart_of_account_id: row.chart_of_account_id,
            chart_of_account_code: row.chart_of_account_code,
            chart_of_account_name: row.chart_of_account_name,
            depts: {},
            total: 0,
          });
        }
        const acc = accountMap.get(row.chart_of_account_id);
        acc.depts[row.department_id] = parseFloat(row.net_amount);
        acc.total += parseFloat(row.net_amount);
      }
      return Array.from(accountMap.values()).sort((a, b) =>
        a.chart_of_account_code.localeCompare(b.chart_of_account_code, undefined, { numeric: true })
      );
    },
    dept_totals() {
      const totals = {};
      for (const row of this.department_raw_data) {
        totals[row.department_id] = (totals[row.department_id] || 0) + parseFloat(row.net_amount);
      }
      return totals;
    },
    dept_grand_total() {
      return Object.values(this.dept_totals).reduce((sum, v) => sum + v, 0);
    },
    period_columns() {
      const map = new Map();
      for (const row of this.period_raw_data) {
        if (!map.has(row.period_id)) {
          map.set(row.period_id, { id: row.period_id, name: row.period_name });
        }
      }
      return Array.from(map.values()).sort((a, b) => a.id - b.id);
    },
    period_pivot_rows() {
      const accountMap = new Map();
      for (const row of this.period_raw_data) {
        if (!accountMap.has(row.chart_of_account_id)) {
          accountMap.set(row.chart_of_account_id, {
            chart_of_account_id: row.chart_of_account_id,
            chart_of_account_code: row.chart_of_account_code,
            chart_of_account_name: row.chart_of_account_name,
            periods: {},
            total: 0,
          });
        }
        const acc = accountMap.get(row.chart_of_account_id);
        acc.periods[row.period_id] = parseFloat(row.net_amount);
        acc.total += parseFloat(row.net_amount);
      }
      return Array.from(accountMap.values()).sort((a, b) =>
        a.chart_of_account_code.localeCompare(b.chart_of_account_code, undefined, { numeric: true })
      );
    },
    period_totals() {
      const totals = {};
      for (const row of this.period_raw_data) {
        totals[row.period_id] = (totals[row.period_id] || 0) + parseFloat(row.net_amount);
      }
      return totals;
    },
    period_grand_total() {
      return Object.values(this.period_totals).reduce((sum, v) => sum + v, 0);
    },
    period_pivot_rows_filtered() {
      if (!this.period_only_with_movement) return this.period_pivot_rows;
      return this.period_pivot_rows.filter(row => row.total !== 0);
    },
    computed_data_diary(){
      if( this.diary_book_type_id == 0) {
        return this.dataDiary;
      }
      return  this.dataDiary.filter((element)=>element.diary_book_type_id == this.diary_book_type_id);
    },
    debitoAndCredito() {
      let debito = 0;
      let credito = 0;
      for (let item of this.computed_data_diary) {
        if (item.entry_type_id == 1) {
          debito +=
            parseFloat(item.amount) *
            parseFloat(item.currency_rate == 0 ? 1 : item.currency_rate);
        }

        if (item.entry_type_id == 2) {
          credito +=
            parseFloat(item.amount) *
            parseFloat(item.currency_rate == 0 ? 1 : item.currency_rate);
        }
      }

      return {
        debito: debito.toFixed(2),
        credito: credito.toFixed(2),
      };
    },

  },
  watch: {
    date(val, newVal) {
      this.searchLoaded();
    },
    date2(val, newVal) {
      this.searchLoaded();
    },
  },
  mounted(){
    this.initialized();
  },
  methods: {
    async initialized(){
      let typeAccounts = await this.api_Get("accounting/type_accounts");
      this.diary_book_types = await typeAccounts.json();

      this.diary_book_types.unshift({
        description: "Todos",
        id: 0,
        code:'ALL'
      });

      const q = this.$route.query;
      if (q.business) {
        this.f_business = parseInt(q.business);
        const savedLocation = parseInt(q.location) || 0;
        if (q.dateStart) this.f_dateStart = q.dateStart;
        if (q.dateEnd) this.f_dateEnd = q.dateEnd;
        this.f_onBusinessChange();
        this.f_location = savedLocation;
        await this.applyFilters();
      }
    },
    f_onBusinessChange() {
      this.f_location = 0;
      const allLocations = this.$store.state.auth.locations || [];
      this.f_locations_list = [
        { text: 'Todas', value: 0 },
        ...allLocations.filter(l => l.bus_id === this.f_business),
      ];
    },
    applyFilters() {
      if (!this.f_business) return;
      return this.searchLoaded({
        business: this.f_business,
        location: this.f_location || 0,
        dateStart: this.f_dateStart,
        dateEnd: this.f_dateEnd,
        diary_book_type: 0,
        category: null,
        subcategory: null,
      });
    },
    showItem(item) {
      if (item.diary_book_type_id == 1 || item.diary_book_type_id == 3) {
        this.showInvoice(item.invoice_id, true);
        return;
      }

      if (item.diary_book_type_id == 4) {
        let route = this.$router.resolve({
          name: "ViewPaymentsCxC",
          params: { id: item.payment_id },
        });
        window.open(route.href);
        return;
      }

      if (item.diary_book_type_id == 5) {
        let route = this.$router.resolve({
          name: "ViewEntryPayroll",
          params: { id: item.diary_book_id },
        });
        window.open(route.href);
        return;
      }
      if (item.diary_book_type_id == 7) {
        let route = this.$router.resolve({
          name: "ViewDirectPayment",
          params: { id: item.direct_payment_id },
        });
        window.open(route.href);
        return;
      }
      if (item.diary_book_type_id == 8) {
        let route = this.$router.resolve({
          name: "ViewAdjustment",
          params: { id: item.warehouse_adjustment_id },
        });
        window.open(route.href);
        return;
      }
      if (item.diary_book_type_id == 10) {
        let route = this.$router.resolve({
          name: "ViewRevaluation",
          params: { id: item.diary_book_id },
        });
        window.open(route.href);
        return;
      }
    },
    getDate(date) {
      let newDate = moment(date).format("YYYY-MM-DD HH:MM:SS A").toString();
      return newDate;
    },
    updateRange(item) {
      if (item == 1) {
        this.date = moment().format("YYYY-MM-DD");
        this.date2 = moment().format("YYYY-MM-DD");
      }
      if (item == 3) {
        this.date = moment().startOf("month").format("YYYY-MM-DD");
        this.date2 = moment().endOf("month").format("YYYY-MM-DD");
      }
      if (item == 2) {
        this.date = moment().startOf("week").format("YYYY-MM-DD");
        this.date2 = moment().endOf("week").format("YYYY-MM-DD");
      }

      if (item == 4) {
        this.date = moment().startOf("year").format("YYYY-MM-DD");
        this.date2 = moment().endOf("year").format("YYYY-MM-DD");
      }

      // this.searchLoaded();
    },
    async exportToExcel() {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Movimientos");

      // Header Info
      worksheet.mergeCells("A1:F1");
      worksheet.mergeCells("A2:F2");
      worksheet.mergeCells("A3:F3");

      const headerCell = worksheet.getCell("A1");
      const dateCell = worksheet.getCell("A2");
      const businessCell = worksheet.getCell("A3");

      headerCell.value = `${this.accountTitle.name} - ${this.accountTitle.code}${this.accountTitle.hasChildren ? ' (Incluyendo subcuentas)' : ''}`;  
      dateCell.value = `Período: ${moment(this.lastFilters.dateStart).format(
        "DD/MM/YYYY"
      )} - ${moment(this.lastFilters.dateEnd).format("DD/MM/YYYY")}`;
      businessCell.value = `Unidad de Negocio: ${
        this.computed_data_diary[0]?.business_unit_description || ""
      }`;

      headerCell.font = { bold: true, size: 14 };
      dateCell.font = { size: 12 };
      businessCell.font = { size: 12 };

      // Data columns start at row 5
      worksheet.getRow(5).values = [
        "Unidad de negocio",
        "Location",
        "Asiento",
        "Tipo",
        "Codigo Cuenta",
        "Cuenta",
        "Categoria",
        "Sub categoria",
        "Fecha",
        "Tercero",
        "Nota",
        "Moneda",
        "Tasa",
        "Monto",
        `Débito (${this.currency})`,
        `Crédito (${this.currency})`,
      ];

      worksheet.columns = [
        { key: "business_unit_description", width: 25 },
        { key: "location_description", width: 25 },
        { key: "diary_book_code", width: 20 },
        { key: "diary_book_type_description", width: 20 },
        { key: "chart_of_account_code", width: 15 },
        { key: "chart_of_account_name", width: 20 },
        { key: "category_name", width: 20 },
        { key: "subcategory_name", width: 20 },
        { key: "created_date", width: 20 },
        { key: "entity_name", width: 30 },
        { key: "note", width: 30 },
        { key: "currency_code", width: 10 },
        { key: "currency_rate", width: 10 },
        { key: "amount", width: 15 },
        { key: "debito", width: 15 },
        { key: "credito", width: 15 },
      ];

      // Start adding data from row 6
      let rowNumber = 6;
      this.computed_data_diary.forEach((item) => {
        const amount =  item.amount * parseFloat(item.currency_rate == 0 ? 1 : item.currency_rate);
        worksheet.addRow({
          business_unit_description: item.business_unit_description,
          location_description: item.location_description,
          diary_book_code: item.diary_book_code,
          diary_book_type_description:item.diary_book_type_description,
          chart_of_account_code: item.chart_of_account_code,
          chart_of_account_name: item.chart_of_account_name,
          category_name: item.category_name,
          subcategory_name: item.subcategory_name,
          created_date: item.effective_date,
          entity_name: item.entity_name,
          note: item.note,
          currency_code: item.currency_code,
          currency_rate: parseFloat(item.currency_rate),
          amount: parseFloat(item.amount),
          debito: item.entry_type_id == 1 ? amount : "",
          credito: item.entry_type_id == 2 ? amount : "",
        });
        rowNumber++;
      });

      worksheet.addRow({});
      rowNumber++;

      worksheet.addRow({
        diary_book_code: "",
        business_unit_description: "",
        created_date: "",
        entity_name: "TOTAL",
        debito: this.debitoAndCredito.debito,
        credito: this.debitoAndCredito.credito,
      });

      worksheet.addRow({
        diary_book_code: "",
        business_unit_description: "",
        created_date: "",
        entity_name: "NETO",
        debito: "",
        credito: this.debitoAndCredito.debito - this.debitoAndCredito.credito,
      });

      // Style the header row
      worksheet.getRow(5).font = { bold: true };
      worksheet.getRow(5).alignment = { vertical: "middle", horizontal: "center" };

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `Movimientos_${
        this.computed_data_diary[0]?.business_unit_description
      }_Desde_${moment(this.lastFilters.dateStart).format("DD-MM-YYYY")}_Hasta_${moment(
        this.lastFilters.dateEnd
      ).format("DD-MM-YYYY")}.xlsx`;
      link.click();
      window.URL.revokeObjectURL(url);
    },
    async exportDeptToExcel() {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Departamento");
      const accountingFmt = '#,##0.00;[Red](#,##0.00)';
      const deptCols = this.dept_columns;
      const totalCols = 2 + deptCols.length + 1;

      worksheet.mergeCells(1, 1, 1, totalCols);
      const titleCell = worksheet.getCell(1, 1);
      titleCell.value = 'Breakdown by Account & Department';
      titleCell.font = { bold: true, size: 14 };
      titleCell.alignment = { horizontal: 'center' };

      worksheet.mergeCells(2, 1, 2, totalCols);
      const subtitleCell = worksheet.getCell(2, 1);
      subtitleCell.value = `${this.accountTitle.name} - ${this.accountTitle.code}`;
      subtitleCell.font = { size: 12 };
      subtitleCell.alignment = { horizontal: 'center' };

      const headerRow = worksheet.getRow(4);
      headerRow.values = ['Account', 'Description', ...deptCols.map(d => d.id), 'Total'];
      headerRow.font = { bold: true };
      headerRow.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFD3D3D3' } };
      headerRow.alignment = { horizontal: 'center' };

      worksheet.getColumn(1).width = 12;
      worksheet.getColumn(2).width = 38;
      for (let i = 3; i <= totalCols; i++) {
        worksheet.getColumn(i).width = 15;
        worksheet.getColumn(i).alignment = { horizontal: 'right' };
      }

      for (const row of this.dept_pivot_rows) {
        const rowData = [row.chart_of_account_code, row.chart_of_account_name];
        for (const dept of deptCols) {
          const v = this.getDeptAmount(row, dept.id);
          rowData.push(v !== null ? v : 0);
        }
        rowData.push(row.total);
        const wsRow = worksheet.addRow(rowData);
        for (let i = 3; i <= totalCols; i++) {
          wsRow.getCell(i).numFmt = accountingFmt;
        }
      }

      const totalsData = ['', 'Total general', ...deptCols.map(d => this.dept_totals[d.id] || 0), this.dept_grand_total];
      const totRow = worksheet.addRow(totalsData);
      totRow.font = { bold: true };
      for (let i = 3; i <= totalCols; i++) {
        totRow.getCell(i).numFmt = accountingFmt;
      }

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `Breakdown_Dept_${this.accountTitle.code}_${moment().format('YYYY-MM-DD')}.xlsx`;
      link.click();
      window.URL.revokeObjectURL(url);
    },
    async exportPeriodToExcel() {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Períodos");
      const accountingFmt = '#,##0.00;[Red](#,##0.00)';
      const perCols = this.period_columns;
      const totalCols = 2 + perCols.length + 1;

      worksheet.mergeCells(1, 1, 1, totalCols);
      const titleCell = worksheet.getCell(1, 1);
      titleCell.value = 'Breakdown by Account & Period';
      titleCell.font = { bold: true, size: 14 };
      titleCell.alignment = { horizontal: 'center' };

      worksheet.mergeCells(2, 1, 2, totalCols);
      const subtitleCell = worksheet.getCell(2, 1);
      subtitleCell.value = `${this.accountTitle.name} - ${this.accountTitle.code}`;
      subtitleCell.font = { size: 12 };
      subtitleCell.alignment = { horizontal: 'center' };

      const headerRow = worksheet.getRow(4);
      headerRow.values = ['Account', 'Description', ...perCols.map(p => p.name), 'Amount'];
      headerRow.font = { bold: true };
      headerRow.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFD3D3D3' } };
      headerRow.alignment = { horizontal: 'center' };

      worksheet.getColumn(1).width = 12;
      worksheet.getColumn(2).width = 38;
      for (let i = 3; i <= totalCols; i++) {
        worksheet.getColumn(i).width = 15;
        worksheet.getColumn(i).alignment = { horizontal: 'right' };
      }

      for (const row of this.period_pivot_rows) {
        const rowData = [row.chart_of_account_code, row.chart_of_account_name];
        for (const per of perCols) {
          const v = this.getPeriodAmount(row, per.id);
          rowData.push(v !== null ? v : 0);
        }
        rowData.push(row.total);
        const wsRow = worksheet.addRow(rowData);
        for (let i = 3; i <= totalCols; i++) {
          wsRow.getCell(i).numFmt = accountingFmt;
        }
      }

      const totalsData = ['', 'Total general', ...perCols.map(p => this.period_totals[p.id] || 0), this.period_grand_total];
      const totRow = worksheet.addRow(totalsData);
      totRow.font = { bold: true };
      for (let i = 3; i <= totalCols; i++) {
        totRow.getCell(i).numFmt = accountingFmt;
      }

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `Breakdown_Period_${this.accountTitle.code}_${moment().format('YYYY-MM-DD')}.xlsx`;
      link.click();
      window.URL.revokeObjectURL(url);
    },
    async searchLoaded(filters) {
      this.loading = true;
      let currency = this.$store.state.auth.bussines_units.find(
        (element) => element.value == filters.business
      );

      if (currency == undefined) {
        this.loading = false;
        return;
      }
      this.currency = currency.currency_code;
      this.lastFilters = filters;

      const responseRequest = await this.api_Post("accounting/diary_book_detail_tree", {
        chart_of_account_id: this.$route.params.id,
        business_unit_id: filters.business != 0 ? filters.business : null,
        location_id: filters.location != 0 ? filters.location : null,
        dateStart: filters.dateStart != 0 ? filters.dateStart : null,
        dateEnd: filters.dateEnd != 0 ? filters.dateEnd : null,
      });

      if (!responseRequest.ok) {
        this.loading = false;
        return;
      }

      let dataDiarys = await responseRequest.json();

      this.dataDiary = dataDiarys;
      for (let key in this.dataDiary) {
        this.dataDiary[key].effective_date = moment(this.dataDiary[key].effective_date).format("DD/MM/YYYY HH:mm:ss");
      }

      this.loading = false;
      if (this.view_mode === 'department') {
        await this.loadDepartmentData();
      } else if (this.view_mode === 'period') {
        await this.loadCalendars();
        await this.loadPeriodData();
      }
    },
    async onViewModeChange(newMode) {
      sessionStorage.setItem('diary_view_mode', newMode);
      if (newMode === 'department') {
        this.loadDepartmentData();
      } else if (newMode === 'period') {
        if (this.lastFilters && this.lastFilters.business) {
          await this.loadCalendars();
          await this.loadPeriodData();
        }
      }
    },
    goBack() {
      if (window.history.length > 1) {
        window.close();
      } else {
        this.$router.back();
      }
    },
    drillDownAccount(row) {
      const route = this.$router.resolve({
        name: 'ViewEntryDiaryBook',
        params: { id: row.chart_of_account_id },
        query: {
          account_name: row.chart_of_account_name,
          account_code: row.chart_of_account_code,
          has_children: '0',
          business: this.f_business || '',
          location: this.f_location || 0,
          dateStart: this.f_dateStart || '',
          dateEnd: this.f_dateEnd || '',
        },
      });
      window.open(route.href, '_blank');
    },
    async loadCalendars() {
      if (!this.lastFilters || !this.lastFilters.business) return;
      const data = await this.api_Post('accounting/calendar_periods_revaluate', {
        id: this.lastFilters.business,
      });
      const result = await data.json();
      this.calendars = result.sort((a, b) => a.accounting_calendar_id - b.accounting_calendar_id);
      if (this.calendars.length > 0) {
        const qCalId = this.$route.query.calendar_id ? parseInt(this.$route.query.calendar_id) : null;
        const matchedCal = qCalId && this.calendars.find(c => c.accounting_calendar_id === qCalId);
        this.current_calendar = matchedCal
          ? matchedCal.accounting_calendar_id
          : this.calendars[this.calendars.length - 1].accounting_calendar_id;
        this.showPeriodsList(this.current_calendar);
      }
    },
    onCalendarChange(id) {
      this.showPeriodsList(id);
    },
    showPeriodsList(calendarId) {
      this.period_periods_list = [];
      this.current_period_id = null;
      const cal = this.calendars.find(c => c.accounting_calendar_id == calendarId);
      if (!cal) return;
      const calYear = cal.name;
      const per = cal.periods
        .map(p => ({
          ...p,
          column_name: `${calYear}-${p.accounting_period_id}`,
          period_label_plain: `Periodo: ${p.accounting_period_id} - ${moment(p.date_from).format('DD-MMMM-YYYY')} - ${moment(p.date_to).format('DD-MMMM-YYYY')}`,
          period_label:
            `<span style="color:blue;">Periodo: ${p.accounting_period_id}</span> - ` +
            moment(p.date_from).format('DD-MMMM-YYYY') +
            ' - ' +
            moment(p.date_to).format('DD-MMMM-YYYY'),
        }))
        .sort((a, b) => a.accounting_period_id - b.accounting_period_id);
      this.period_periods_list = per;
      const qPeriodNum = this.$route.query.period_num ? parseInt(this.$route.query.period_num) : null;
      const matchedPeriod = qPeriodNum && per.find(p => p.accounting_period_id === qPeriodNum);
      this.current_period_id = matchedPeriod ? matchedPeriod.id : per[per.length - 1].id;
    },
    async loadDepartmentData() {
      this.loading_dept = true;
      const filters = this.lastFilters || {};
      const responseRequest = await this.api_Post("accounting/diary_book_tree_by_department", {
        chart_of_account_id: this.$route.params.id,
        business_unit_id: filters.business && filters.business != 0 ? filters.business : null,
        location_id: filters.location && filters.location != 0 ? filters.location : null,
        dateStart: filters.dateStart && filters.dateStart != 0 ? filters.dateStart : null,
        dateEnd: filters.dateEnd && filters.dateEnd != 0 ? filters.dateEnd : null,
      });
      if (responseRequest.ok) {
        this.department_raw_data = await responseRequest.json();
      }
      this.loading_dept = false;
    },
    getDeptAmount(row, dept_id) {
      return row.depts[dept_id] !== undefined ? row.depts[dept_id] : null;
    },
    getPeriodAmount(row, period_id) {
      return row.periods[period_id] !== undefined ? row.periods[period_id] : null;
    },
    async loadPeriodData() {
      if (!this.current_period_id || this.period_periods_list.length === 0) return;
      const selected = this.period_periods_list.find(p => p.id === this.current_period_id);
      if (!selected) return;
      const periodsUpTo = this.period_periods_list
        .filter(p => p.accounting_period_id <= selected.accounting_period_id)
        .sort((a, b) => a.accounting_period_id - b.accounting_period_id);
      if (periodsUpTo.length === 0) return;
      const filters = this.lastFilters || {};
      this.loading_period = true;
      const responseRequest = await this.api_Post('accounting/diary_book_tree_by_period', {
        chart_of_account_id: this.$route.params.id,
        business_unit_id: filters.business && filters.business != 0 ? filters.business : null,
        location_id: filters.location && filters.location != 0 ? filters.location : null,
        periods: periodsUpTo.map(p => ({
          id: p.accounting_period_id,
          name: p.column_name || String(p.accounting_period_id),
          date_from: moment(p.date_from).format('YYYY-MM-DD'),
          date_to: moment(p.date_to).format('YYYY-MM-DD'),
        })),
      });
      if (responseRequest.ok) {
        this.period_raw_data = await responseRequest.json();
      }
      this.loading_period = false;
    },
    formatPivotAmount(value) {
      if (value === null || value === undefined) return '0.00';
      const formatted = this.currencyFormat(Math.abs(value));
      if (value < -0.005) return `(${formatted})`;
      if (value > 0.005) return formatted;
      return '0.00';
    },
    async getData() {
      this.id_account = this.$route.params.id;

      this.loading = true;
      this.itemsBussines = Object.assign([], this.$store.state.auth.bussines_units);
      this.rangeSelected = this.rangeTime[2];
      //combo locations----------------------------------------------
      this.itemsLocations = this.$store.state.auth.locations;

      this.filters.business = this.itemsBussines[0].value;

      //  this.itemsBussines.unshift({ text: "Todas", value: 0 });

      this.itemsDepartment = await this.g_departments();
      this.itemsDepartment.unshift({ text: "Todos", value: 0 });
      this.filters.department_id = this.itemsDepartment[0].value;
      this.itemsLocations2.unshift({ text: "Todas", value: 0 });
      this.filters.location = this.itemsLocations2[0].value;
      let resultCategoryDgii = await this.api_Get("accounting/category_dgii");

      const dataCategoryDgii = await resultCategoryDgii.json();
      //   let resultDiary = await this.api_Get("accounting/diary_book");
      //   let dataDiarys = await resultDiary.json();
      const responseDiary = await this.api_Post("accounting/account_entry", {
        id_account: this.id_account,
      });

      let dataDiarys = await responseDiary.json();

      this.dataDiary = dataDiarys;

      for (let item of dataCategoryDgii) {
        this.categoryDgii.push({ text: item.name, value: item.id });
      }
      this.CategoryDgii = dataCategoryDgii;

      let resultTypeAccounts = await this.api_Get("accounting/accountsUsable");
      const dataTypeAccounts = await resultTypeAccounts.json();

      let child = [];
      for (let items of dataTypeAccounts) {
        child.push({
          id: items.id,
          name: items.name,
          parent: items.parent_id,
          code: items.code,
          note: items.note,
          account_type_id: items.account_type_id,
          dgii_category_id: items.dgii_category_id,
        });
        //  }
      }

      const nest = (items, id = null, link = "parent") =>
        items
          .filter((item) => item[link] === id)
          .map((item) => ({ ...item, children: nest(items, item.id) }));

      let result = nest(child);

      this.items = result;
      this.loading = false;
    },
    async save() {
      if (this.editedItem.name == "") {
        this.$toast.warning("Digita el nombre de la cuenta!");
        return;
      }

      if (this.editedItem.code === ``) {
        this.$toast.warning("Digita el codigo de la cuenta!");
        return;
      }

      if (this.selectedCategoryDgii == "") {
        this.$toast.warning("Digita el codigo de la dgii!");
        return;
      }
      if (this.editedIndex > -1) {
        const responseRequest = await this.api_Post("accounting/accounting_account", {
          chart_of_account_id: this.editedItem.id,
          account_type_id: this.editedItem.account_type_id,
          parent_id: this.editedItem.parent,
          dgii_category_id: this.selectedCategoryDgii.value,
          code: this.editedItem.code,
          name: this.editedItem.name,
          note: this.editedItem.note,
        });

        if (responseRequest.status == 200) {
          this.getData();
          this.$toast.success("cuenta actualizada con exito!");
        } else {
          this.$toast.error("error al crear la cuenta!");
        }
      } else {
        const responseRequest = await this.api_Post("accounting/accounting_account", {
          chart_of_account_id: null,
          account_type_id: this.itemSaved.account_type_id,
          parent_id: this.itemSaved.id,
          dgii_category_id: this.selectedCategoryDgii.value,
          code: this.editedItem.code,
          name: this.editedItem.name,
          note: this.editedItem.note,
        });

        if (responseRequest.status == 200) {
          this.getData();
          this.$toast.success("cuenta creadad con exito!");
        } else {
          this.$toast.error("error al crear la cuenta!");
        }
      }
      this.close();
    },
    updateCombo(itemsOrigen, itemsDestino, condicion, combo) {
      itemsDestino.splice(0, itemsDestino.length);

      for (let item of itemsOrigen) {
        if (item.bus_id === condicion) {
          itemsDestino.push({
            value: item.value,
            text: item.text,
            routes: item.routes,
          });
        }
      }
      // itemsDestino.unshift({ text: "Todas", value: 0 });
      this.filters.location = this.itemsLocations2[0].value;

      return itemsDestino;
    },
    editItem(item) {
      this.selectedCategoryDgii = this.editedItem.dgii_category_id;
      this.editedIndex = 0;
      this.editedItem = Object.assign({}, item);
      this.seletecName = this.editedItem.name;
      this.selectedCategoryDgii;
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
    addAccount(item) {
      this.editedItem = [];
      this.itemSaved = [];
      this.selectedCategoryDgii = "";
      this.editedIndex = -1;
      let data = Object.assign({}, item);
      this.itemSaved = data;
      this.seletecName = data.name;
      this.editedItem.name = "";
      this.editedItem.code = "";
      this.dialog = true;
    },
  },
};
</script>

<style scoped>
.dept-pivot-wrapper {
  overflow-x: auto;
  overflow-y: auto;
  max-height: 55vh;
}
.dept-pivot-table {
  border-collapse: collapse;
  width: 100%;
  font-size: 12px;
}
.dept-th {
  position: sticky;
  top: 0;
  background: #f5f5f5;
  border: 1px solid #e0e0e0;
  padding: 6px 10px;
  white-space: nowrap;
  z-index: 2;
  font-weight: 600;
  color: #424242;
  text-align: right;
}
.dept-th.dept-code-col,
.dept-th.dept-name-col {
  text-align: left;
  z-index: 3;
}
.dept-td {
  border: 1px solid #e0e0e0;
  padding: 4px 10px;
  white-space: nowrap;
  text-align: right;
}
.dept-code-col {
  min-width: 90px;
  font-weight: 500;
}
.dept-name-col {
  min-width: 200px;
  text-align: left !important;
}
.dept-amount-col {
  min-width: 110px;
  font-family: monospace;
}
.dept-total-col {
  background: #fafafa;
  font-weight: 600;
  border-left: 2px solid #bdbdbd;
}
.dept-negative {
  color: #e53935;
}
.dept-positive {
  color: #2e7d32;
}
.dept-zero {
  color: #bdbdbd;
}
.dept-row:hover td {
  background: #f3f8ff;
}
.dept-footer-row td {
  background: #eeeeee;
  font-weight: 700;
  border-top: 2px solid #9e9e9e;
}
.dept-footer-label {
  text-align: left !important;
}
.dept-header-id {
  font-size: 13px;
  font-weight: 700;
  color: #1565c0;
  line-height: 1.2;
}
.dept-header-name {
  font-size: 10px;
  font-weight: 400;
  color: #757575;
  line-height: 1.2;
}
</style>
